import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { css } from "styled-components";
import { genericColorCombination, resolveAnimations } from "~/lib/resolvers";
const Wrapper = styled.span`
  border-radius: ${_ref => {
  let {
    $rounded,
    theme
  } = _ref;
  return $rounded ? "2em" : theme.shape.borderRadius.primary;
}};
  background-color: ${_ref2 => {
  let {
    $color,
    theme
  } = _ref2;
  return genericColorCombination(theme, $color).background;
}};
  color: ${_ref3 => {
  let {
    $color,
    theme
  } = _ref3;
  return genericColorCombination(theme, $color).color;
}};
  font-weight: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.typography.fontWeight.semiBold;
}};
  white-space: nowrap;
  position: relative;
  ${_ref5 => {
  let {
    $fontSize,
    theme
  } = _ref5;
  return $fontSize && `font-size: ${theme.typography.fontStep * $fontSize}rem`;
}};
  ${_ref6 => {
  let {
    $lineHeight,
    theme
  } = _ref6;
  return $lineHeight && `line-height: ${theme.typography.fontStep * $lineHeight}rem`;
}};
  ${_ref7 => {
  let {
    $weight,
    theme
  } = _ref7;
  return $weight && `font-weight: ${theme.typography.fontWeight[$weight]}`;
}};
  ${_ref8 => {
  let {
    $s,
    theme
  } = _ref8;
  return theme.spacing.resolve(theme, $s);
}};
  ${_ref9 => {
  let {
    $display
  } = _ref9;
  return $display && `display: ${$display}`;
}};
  ${_ref10 => {
  let {
    $pulse,
    $color,
    theme
  } = _ref10;
  return $pulse && resolveAnimations.pulse("badgePulse", theme, $color);
}}
  ${_ref11 => {
  let {
    $clickable,
    $rounded,
    theme
  } = _ref11;
  return $clickable && css`
      cursor: pointer;

      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: background-color 200ms ease-out;
        background-color: transparent;
        border-radius: ${$rounded ? "2em" : theme.shape.borderRadius.primary};
        z-index: 1;
      }
      &:hover:before {
        background-color: ${theme.colors.action.hover};
      }
    `;
}}
`;
const Badge = _ref12 => {
  let {
    color = "primary",
    s,
    fontSize = 3,
    lineHeight,
    display,
    weight,
    rounded = false,
    pulse = false,
    onClick,
    children,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $color: color,
    $fontSize: fontSize,
    $lineHeight: lineHeight,
    $display: display,
    $weight: weight,
    $rounded: rounded,
    $pulse: pulse,
    $clickable: typeof onClick === "function",
    onClick: onClick,
    $s: {
      px: 2,
      py: 1,
      ...s
    }
  }, rest), children);
};
export default Badge;